import {AxiosInstance} from "axios";

import FileRepositoryInterface from "@/services/File-manager/interfaces/file.interface";
import {FileEntity, FileUploadRequestDTO} from "@fenix/file-manager-entities/file-manager-entities";
import {AccessType} from "@fenix/file-manager-entities";

export default class FileRepository implements FileRepositoryInterface{
  constructor(
    private axios: AxiosInstance,
  ) {
  }
  public async uploadFiles(uploadDTO: FileUploadRequestDTO, files: File[]): Promise<FileEntity[]> {
    const formData = new FormData()
    files.forEach((file) => formData.append('files', file));
    formData.append('isPrivate', String(uploadDTO.isPrivate));
    formData.append('folderId', String(uploadDTO.folderId))
    if (uploadDTO.access && uploadDTO.access.length) {
      formData.append('access', JSON.stringify(uploadDTO.access))
    }
    const res = await this.axios.post('/internal-file-manager/upload-files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return res.data;
  }

  async deleteFiles(fileIds: number[]): Promise<void> {
    const url = '/internal-file-manager/delete-files'
    await this.axios.delete(url, {
      params: {
        ids: fileIds,
      }
    })
  }

  public async setPermission(fileId: number | string, type: AccessType, accessorId: string): Promise<void> {
    await this.axios.post(`internal-file-manager/access`, {
      fileId,
      accessType: type,
      grantAccessTo: accessorId,
    });
  }

  public async downloadFile(file: FileEntity): Promise<void> {
    const filePath = file.folder?.private ? `private?file=${file.path}` : `public/${file.path}`;
    const res = await this.axios.get(`/internal-file-manager/${filePath}`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file.name);
    link.click();
  }
}
